import {SIDE_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class CornerCaddie extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'corner_caddie';
    this.partName = 'Corner Caddie';
    this.translateId = "visualizer.bathroom.accessories.corner_caddie";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [SIDE_POSITIONS[0]]: null,
        [SIDE_POSITIONS[1]]: null,
      };
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new CornerCaddie(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  availableFeatures(features) {
    return features.filter(feature => feature.partNumber === 1)
  }

  handleClick() {
    const accessoriesParent = this.getParent().getParent();
    accessoriesParent.caddie_type = this.partId;
    super.handleClick();
  }

  setLayers(layout) {

    const accessoriesParent = this.getParent();
    if (accessoriesParent.caddie_type !== this.partId) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      // this.checkIfFeaturePartIsMatching();
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Accessories.CornerCaddie + keyIndex*10;
        }
      })
    }
  }
}
